import { isEmpty } from '../../Utils/Validations'
import './NumberInput.scss'

interface NumberInputProps {
  value?: number
  onChange?: (newValue: number) => void
  label?: string
  helperText?: string
  placeholder?: number
  isValid?: boolean
  isReadOnly?: boolean
  min?: number
  max?: number
  precision?: number
}

export function NumberInput({
  value,
  onChange,
  label,
  helperText,
  placeholder,
  isValid,
  isReadOnly,
  min,
  max,
  precision,
}: NumberInputProps) {
  const step = precision !== undefined ? 1 / Math.pow(10, precision) : undefined
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = Number(event.target.value)

    if (min !== undefined && value < min) value = min
    if (max !== undefined && value > max) value = max
    if (precision !== undefined && value !== +value.toFixed(precision))
      value = +value.toFixed(precision)

    if (onChange) {
      onChange(value)
    }
  }

  return (
    <div
      className={`number-input ${isValid === false ? 'invalid' : ''} ${
        isReadOnly ?? false ? 'is-read-only' : ''
      }`}
    >
      {!isEmpty(label) ? <div className="input-label">{label}</div> : null}
      <input
        type="number"
        className="input-element"
        value={value}
        onChange={handleInputChange}
        placeholder={`${placeholder}`}
        min={min}
        max={max}
        step={step}
        readOnly={isReadOnly}
      />
      {!isEmpty(helperText) ? (
        <div className="input-helper-text">{helperText}</div>
      ) : null}
    </div>
  )
}
